export enum GiftFundCodesEnum {
  Birthday = 'BG',
  Child = 'GG',
  Family = 'FG',
  Center = 'PG',
}

export enum GiftLimitReason {
  AlreadyGivenBirthday = 'BG-Gift-Already-Given',
  AlreadyGivenChild = 'GG-Gift-Already-Given',
  AlreadyGivenMaxTimesChild = 'GG-Gift-Already-Given-Max-Times',
  AlreadyGivenGraduation = 'GDG-Gift-Already-Given',
  AlreadyGivenFinal = 'FLG-Gift-Already-Given',
  AlreadyGivenMaxAmountCenter = 'PG-Max-Amount-Already-Given',
  AlreadyGivenMaxAmountFamily = 'FG-Max-Amount-Already-Given',
  IneligibleBeneficiaryExited = 'Beneficiary-Exited',
  IneligiblePlannedExit = 'Beneficiary-PlannedExit',
}
